"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sum = sum;
exports.avg = avg;
exports.distinct = distinct;
exports.distinctItem = distinctItem;
exports.max = max;
exports.min = min;
/**
 * sumuje wartości w tablicy
 * @param array tablica do sumowania
 * @param prop pole w wierszu podlegające sumowaniu, można pominąć
 */
function sum(array, prop) {
    //const $result = 0;
    if (prop) {
        if (typeof prop === 'string') {
            let res = 0;
            for (const item of array) {
                res += item[prop];
            }
            return res;
            //return array.reduce((partialSum, a) => partialSum + (a as any)[prop], 0)
        }
        else {
            return array.reduce((partialSum, a, index) => {
                const v = prop(a, index);
                if (v !== undefined) {
                    return partialSum + v;
                }
                else {
                    return partialSum;
                }
            }, 0);
        }
    }
    else {
        return array.reduce((partialSum, a) => partialSum + a, 0);
    }
}
/**
 * średnia wartośc z tablicy
 * @param array tablica do sumowania
 * @param prop pole w wierszu podlegające sumowaniu, można pominąć
 */
function avg(array, prop) {
    if (prop) {
        if (typeof prop === 'string') {
            return array.length === 0 ? 0 : sum(array, prop) / array.length;
        }
        else {
            let count = 0;
            const ss = array.reduce((partialSum, a, index) => {
                const v = prop(a, index);
                if (v !== undefined) {
                    count++;
                    return partialSum + v;
                }
                else {
                    return partialSum;
                }
            }, 0);
            return count == 0 ? 0 : ss / count;
        }
    }
    else {
        return array.length === 0 ? 0 : sum(array, prop) / array.length;
    }
    // return array.length === 0 ? 0 : sum(array, prop) / array.length;
}
/**
 * unikalne wartości z tablicy
 * @param array tablica do sumowania
 * @param prop zwracane pole z wiersza tablicy
 */
function distinct(array, prop) {
    const $result = [];
    const $distinct = {};
    if (prop) {
        const isString = typeof prop === 'string';
        for (let i = 0; i < array.length; i++) {
            const $v = isString ? array[i][prop] : prop(array[i], i);
            if ($v !== undefined && $distinct[$v] === undefined) {
                $result.push($v);
                $distinct[$v] = i;
            }
        }
    }
    else {
        for (let i = 0; i < array.length; i++) {
            if ($distinct[array[i]] === undefined) {
                $result.push(array[i]);
                $distinct[array[i]] = i;
            }
        }
    }
    return $result;
}
/**
 * unikalne wiersze z tablicy
 * @param array tablica do sumowania
 * @param prop pole do określenia unikalności wiersza
 */
function distinctItem(array, prop) {
    const $result = [];
    const $distinct = {};
    if (prop) {
        const isString = typeof prop === 'string';
        for (let i = 0; i < array.length; i++) {
            const $v = isString ? array[i][prop] : prop(array[i], i);
            if ($v !== undefined && $distinct[$v] === undefined) {
                $result.push(array[i]);
                $distinct[$v] = i;
            }
        }
    }
    else {
        for (let i = 0; i < array.length; i++) {
            if ($distinct[array[i]] === undefined) {
                $result.push(array[i]);
                $distinct[array[i]] = i;
            }
        }
    }
    return $result;
}
/**
 * zwraca maksymalną wartość
 * @param values tablica wartości
 * @param prop sprawdzane property
 */
function max(array, prop) {
    // let maxValue = -23432434234;
    if (array.length == 0)
        return;
    if (prop) {
        if (typeof prop === 'string') {
            array.reduce((partialMax, a) => (a[prop] > partialMax ? a[prop] : partialMax), array[0][prop]);
        }
        else {
            return array.reduce((partialMax, a, index) => {
                const v = prop(a, index);
                if (v !== undefined && (partialMax == undefined || v > partialMax))
                    return v;
                return partialMax;
                //prop(a, index) > partialMax ? prop(a, index) : partialMax, prop(array[0], 0)
            }, undefined);
        }
    }
    else {
        return array.reduce((partialMax, a) => (a > partialMax ? a : partialMax), array[0]);
    }
}
/**
 * zwraca minimalną wartość
 * @param values tablica wartości
 * @param prop sprawdzane property
 */
function min(array, prop) {
    if (array.length == 0)
        return;
    if (prop) {
        if (typeof prop === 'string') {
            array.reduce((partialMin, a) => (a[prop] < partialMin ? a[prop] : partialMin), array[0][prop]);
        }
        else {
            return array.reduce((partialMin, a, index) => {
                const v = prop(a, index);
                if (v !== undefined && (partialMin == undefined || v < partialMin))
                    return v;
                return partialMin;
            }, undefined);
            //return array.reduce((partialMin, a, index) => prop(a, index) < partialMin ? prop(a, index) : partialMin, prop(array[0], 0))
        }
    }
    else {
        return array.reduce((partialMin, a) => (a < partialMin ? a : partialMin), array[0]);
    }
}
//# sourceMappingURL=aggreagate.js.map